import {Component, effect, inject, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {KEYCLOAK_EVENT_SIGNAL, KeycloakEventType, ReadyArgs, typeEventArgs} from 'keycloak-angular';
import {TranslocoPipe} from '@jsverse/transloco';
import {Select} from 'primeng/select';
import {ManagedProviderResponse, ProviderManagerControllerService} from '@frontend/shared-api';
import {RoleCheckService} from '../../../shared/services/role-check.service';
import {ProviderTenantSelectionService} from '../../../shared/services/provider-tenant-selection.service';
import {APP_ROUTES} from '../../../app.routes';

@Component({
  selector: 'app-provider-tenant-switcher',
  imports: [FormsModule, Select, TranslocoPipe],
  templateUrl: './provider-tenant-switcher.component.html',
})
export class ProviderTenantSwitcherComponent {
  private readonly keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);
  private readonly roleCheckService = inject(RoleCheckService);
  private readonly providerManagerService = inject(ProviderManagerControllerService);
  private readonly providerTenantSelectionService = inject(ProviderTenantSelectionService);

  readonly providers = signal<ManagedProviderResponse[]>([]);
  readonly selectedTenantId = signal<string | null>(null);

  constructor() {
    effect(() => {
      const keycloakEvent = this.keycloakSignal();
      if (keycloakEvent.type === KeycloakEventType.AuthLogout) {
        this.providers.set([]);
      }
      if (
        keycloakEvent.type === KeycloakEventType.Ready &&
        typeEventArgs<ReadyArgs>(keycloakEvent.args) &&
        this.roleCheckService.hasProviderManagerRole()
      ) {
        this.loadProviders();
      }
    });
  }

  switchProvider(tenantId: string): void {
    this.providerTenantSelectionService.selectTenant(tenantId);
    window.location.assign(APP_ROUTES.PROVIDER_TENDERS);
  }

  private loadProviders(): void {
    this.selectedTenantId.set(this.providerTenantSelectionService.getSelectedTenantId());
    this.providerManagerService.getManagedProviders().subscribe((providers) => {
      this.providers.set(providers);
    });
  }
}
